import { useEffect } from "react";

export function Impressum({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-fade-in"
      style={{ animationDuration: "0.3s" }}
    >
      <div className="absolute inset-0 bg-stone-900/60 backdrop-blur-sm" onClick={onClose} />

      <div className="relative bg-sand-50 max-w-2xl w-full max-h-[85vh] overflow-y-auto rounded-2xl p-8 md:p-10 shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full hover:bg-sand-100 text-stone-700 transition-colors"
          aria-label="Schliessen"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>

        <h2 className="font-display text-3xl text-stone-900 mb-6 tracking-tight font-semibold">Impressum</h2>

        <div className="space-y-5 text-sm text-stone-700 font-light leading-relaxed">
          <section>
            <h3 className="text-stone-900 font-medium mb-1">Angaben gemäß § 5 TMG</h3>
            <p>Christine Pfeifle-Rauch</p>
            <p>ziel balance</p>
            <p>Grüntenstr. 3</p>
            <p>88289 Waldburg</p>
          </section>

          <section>
            <h3 className="text-stone-900 font-medium mb-1">Kontakt</h3>
            <p>Telefon: 07529 / 634259</p>
            <p>E-Mail: mail@zielbalance.de</p>
          </section>

          <section>
            <h3 className="text-stone-900 font-medium mb-1">Berufsbezeichnung</h3>
            <p>Pädagogische Kinesiologin</p>
            <p>Lehrerin (GS)</p>
          </section>

          <section>
            <h3 className="text-stone-900 font-medium mb-1">Umsatzsteuer</h3>
            <p>Kleinunternehmerregelung gemäß § 19 UStG.</p>
          </section>

          <section>
            <h3 className="text-stone-900 font-medium mb-1">Verantwortlich für den Inhalt</h3>
            <p>Christine Pfeifle-Rauch (Anschrift wie oben)</p>
          </section>

          <section>
            <h3 className="text-stone-900 font-medium mb-1">Hinweis zur Behandlung</h3>
            <p>
              Die kinesiologischen Behandlungen ersetzen keinen Arztbesuch und stellen
              keine medizinische Heilbehandlung im Sinne des Heilpraktikergesetzes dar.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
